import { get } from '../api.js';
import { setTopbar, lucideIcons, esc } from '../app.js';
import { navigate } from '../router.js';
import { relTime } from '../utils.js';
import { decryptItemSummary } from '../item-decrypt.js';

function itemName(item) {
  const summary = decryptItemSummary(item);
  return summary.name === 'Untitled' ? null : summary.name;
}

export async function renderNotarizations(container) {
  setTopbar('Notarizations', '');

  container.innerHTML = '<p class="loading">Loading...</p>';

  try {
    const [rows, items] = await Promise.all([get('/notarizations'), get('/items').catch(() => [])]);
    const itemMap = new Map(items.map(i => [i.id, i]));

    if (!rows.length) {
      container.innerHTML = `
        <div class="empty">
          <i data-lucide="stamp" style="width:48px;height:48px;color:var(--text-secondary);margin-bottom:12px"></i>
          <p>No notarizations yet</p>
          <p style="font-size:13px;color:var(--text-secondary);margin-top:4px">Notarize an item to create a timestamped proof of existence.</p>
        </div>`;
      lucideIcons();
      return;
    }

    let html = '<div class="list">';
    for (const r of rows) {
      const hashShort = r.content_hash.slice(0, 16) + '...';
      const isGrant = r.event_type === 'grant';
      const icon = isGrant ? 'share-2' : 'stamp';
      let name = null;
      if (r.item_id && itemMap.has(r.item_id)) {
        name = itemName(itemMap.get(r.item_id));
      }
      const title = isGrant
        ? (name ? `Grant: ${esc(name)}` : 'Grant provenance')
        : (name ? esc(name) : relTime(r.timestamp));
      const verified = r.blob_hash ? ' <i data-lucide="shield-check" style="width:10px;height:10px;color:var(--success)"></i>' : '';
      const subtitle = name
        ? `${relTime(r.timestamp)} &middot; <span class="mono">${esc(hashShort)}</span>${verified}`
        : `${relTime(r.timestamp)} &middot; <span class="mono">${esc(hashShort)}</span>${verified}`;
      html += `
        <a class="list-item" href="#/notarizations/${r.id}">
          <div class="list-item-icon"><i data-lucide="${icon}"></i></div>
          <div class="list-item-content">
            <div class="list-item-title">${title}</div>
            <div class="list-item-subtitle" style="font-size:11px">${subtitle}</div>
          </div>
          <div class="list-item-chevron"><i data-lucide="chevron-right"></i></div>
        </a>`;
    }
    html += '</div>';
    container.innerHTML = html;
    lucideIcons();
  } catch (err) {
    container.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
  }
}
